import { render, staticRenderFns } from "./RuleRecordDialog.vue?vue&type=template&id=257afa96&scoped=true&"
import script from "./RuleRecordDialog.vue?vue&type=script&lang=js&"
export * from "./RuleRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257afa96",
  null
  
)

export default component.exports